// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/rag/v1/rag.proto (package mono.rag.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { CreateCollectionRequest, CreateCollectionResponse, DeleteBlocksRequest, DeleteBlocksResponse, DeleteCollectionRequest, DeleteCollectionResponse, EmbedBatchRequest, EmbedBatchResponse, EmbedRequest, EmbedResponse, GetCollectionStatsRequest, GetCollectionStatsResponse, GetDocumentRequest, GetDocumentResponse, IndexBatchRequest, IndexBatchResponse, IndexDocumentRequest, IndexDocumentResponse, SearchRequest, SearchResponse, SearchSimilarRequest, SearchSimilarResponse, SemanticSearchRequest, SemanticSearchResponse } from "./rag_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * RagService provides RAG (Retrieval Augmented Generation) operations.
 *
 * @generated from service mono.rag.v1.RagService
 */ export const RagService = {
    typeName: "mono.rag.v1.RagService",
    methods: {
        /**
     * Search performs hybrid vector + keyword search with permission filtering.
     *
     * @generated from rpc mono.rag.v1.RagService.Search
     */ search: {
            name: "Search",
            I: SearchRequest,
            O: SearchResponse,
            kind: MethodKind.Unary
        },
        /**
     * SearchSimilar performs vector similarity search.
     *
     * @generated from rpc mono.rag.v1.RagService.SearchSimilar
     */ searchSimilar: {
            name: "SearchSimilar",
            I: SearchSimilarRequest,
            O: SearchSimilarResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetDocument retrieves a single document by ID.
     *
     * @generated from rpc mono.rag.v1.RagService.GetDocument
     */ getDocument: {
            name: "GetDocument",
            I: GetDocumentRequest,
            O: GetDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * Embed generates an embedding for a single text input.
     *
     * @generated from rpc mono.rag.v1.RagService.Embed
     */ embed: {
            name: "Embed",
            I: EmbedRequest,
            O: EmbedResponse,
            kind: MethodKind.Unary
        },
        /**
     * EmbedBatch generates embeddings for multiple text inputs.
     *
     * @generated from rpc mono.rag.v1.RagService.EmbedBatch
     */ embedBatch: {
            name: "EmbedBatch",
            I: EmbedBatchRequest,
            O: EmbedBatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * SemanticSearch performs semantic search across documents.
     *
     * @generated from rpc mono.rag.v1.RagService.SemanticSearch
     */ semanticSearch: {
            name: "SemanticSearch",
            I: SemanticSearchRequest,
            O: SemanticSearchResponse,
            kind: MethodKind.Unary
        },
        /**
     * CreateCollection creates a project-scoped vector collection.
     *
     * @generated from rpc mono.rag.v1.RagService.CreateCollection
     */ createCollection: {
            name: "CreateCollection",
            I: CreateCollectionRequest,
            O: CreateCollectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteCollection removes a project-scoped vector collection.
     *
     * @generated from rpc mono.rag.v1.RagService.DeleteCollection
     */ deleteCollection: {
            name: "DeleteCollection",
            I: DeleteCollectionRequest,
            O: DeleteCollectionResponse,
            kind: MethodKind.Unary
        },
        /**
     * GetCollectionStats returns stats for a project collection.
     *
     * @generated from rpc mono.rag.v1.RagService.GetCollectionStats
     */ getCollectionStats: {
            name: "GetCollectionStats",
            I: GetCollectionStatsRequest,
            O: GetCollectionStatsResponse,
            kind: MethodKind.Unary
        },
        /**
     * IndexDocument indexes document blocks into a project-scoped vector collection.
     *
     * @generated from rpc mono.rag.v1.RagService.IndexDocument
     */ indexDocument: {
            name: "IndexDocument",
            I: IndexDocumentRequest,
            O: IndexDocumentResponse,
            kind: MethodKind.Unary
        },
        /**
     * IndexBatch indexes multiple documents in a single call.
     *
     * @generated from rpc mono.rag.v1.RagService.IndexBatch
     */ indexBatch: {
            name: "IndexBatch",
            I: IndexBatchRequest,
            O: IndexBatchResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteBlocks removes named blocks of one tenant (and project) from a
     * collection (REG-51). TENANT/SYSTEM scopes need the internal X-Admin-Secret.
     *
     * @generated from rpc mono.rag.v1.RagService.DeleteBlocks
     */ deleteBlocks: {
            name: "DeleteBlocks",
            I: DeleteBlocksRequest,
            O: DeleteBlocksResponse,
            kind: MethodKind.Unary
        }
    }
};
